module.exports = __webpack_public_path__ + "static/perfect-ads-5194fb1f7b9b11b367ad6fcaee60a1f6.svg";